import styled from 'styled-components';

type ContainerProps = {
  $color: string;
};

export const Container = styled.span<ContainerProps>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-left: auto;
  font-size: 10px;
  line-height: 1.6;
  color: ${({ $color }) => $color};

  & > svg {
    width: 10px;
    height: 10px;
    margin-right: 4px;
  }
`;
